import * as React from 'react';
import * as styles from './ComposerPlaceholder.css';
import { IAIcon } from '../../icon/Icon';

export interface IComposerErrorProps {
  errorMessage: string;
  errorLink?: {
    href: string,
    text: string
  }
  borderRadius?: number;
  onClick: () => void;
}

export interface IComposerErrorState {
  
}

export class IAComposerError extends React.Component<IComposerErrorProps, IComposerErrorState> {
  constructor(props: IComposerErrorProps) {
    super(props);
    this.state = {
    }
  }

  public render(): JSX.Element {
    return <div
      className={styles.IA_composerPlaceholder}
      onClick={() => this.props.onClick()}
      style={{
        borderRadius: this.props.borderRadius ?? 0
      }}
    >
      <div className={styles.IA_composerPlaceholderContent} style={{color: "red"}}>
        <IAIcon
          title="Attention"
          size={40}
          color={"red"}
          style={{ margin: "5px 15px 0 0" }}
        />
        <div className={styles.IA_composerPlaceholderText}>
          {this.props.errorMessage} 
          {this.props.errorLink &&
            <a href={this.props.errorLink.href} target='_blank' style={{ color: "red" }}>
              {this.props.errorLink.text}
            </a>
          }
        </div>
      </div>
    </div>;
  }
}